import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import {  useHistory, useParams } from 'react-router-dom'
import { Form } from "react-bootstrap"
import { swalAlertError } from '../../../utils/swalAlert'
import PalexLogo from '../../header/PalexLogo'
import { viewContactPresentationApi } from '../../../api/accessToPresentationByContact/viewContactPresentationApi'
import { routes } from '../../../constantes/routes'
import { getTokenAndSetInLocalStorage } from '../../../utils/token'
import { infoProfileContactHospitalPresentationActions } from '../../../actions/accessToPresentationByContact/infoProfileContactHospitalPresentationActions'
import RequieredInputs from '../../common/RequiredInputs'
import '../../../assests/styles/onboarding/landing.scss'

const LandingToPresentation = () => {

    const { id } = useParams()
    const history = useHistory()

    const dispatch = useDispatch()
    const getInfoContactHospitalPresentation = () => dispatch(infoProfileContactHospitalPresentationActions.getInfoProfileContactHospitalPresentation(id))
    

    const [telefono, setTelefono] = useState('')
    const [isDisable, setIsDisable] = useState(false)

    const handleChange = (event) => {
        const value = event.target.value
        setTelefono(value)
    }

    const validateForm = () => {
        return telefono.length > 0 
    }

    const handleSubmit = async (event) => {
        event.preventDefault()
        setIsDisable(true)
        let tel = telefono.replace(/ /g, "") //Quitar espacios en blanco
        try {
            const response = await viewContactPresentationApi.goToAccessPresentationOfAContact(parseInt(id), { ContactoTelefono: tel })
            await getTokenAndSetInLocalStorage(response.data)
            getInfoContactHospitalPresentation()
            setIsDisable(false)
            history.push(routes.VIEW_CONTACT_PRESENTATION + id)
        } catch (error) {
            swalAlertError(error.response.data || error.response.statusText)
            setIsDisable(false)
        }
    }

    return (
        <>
            <div className="frameless-login">
                <div className="login-wrap">
                    <PalexLogo/>
                        <Form>
                            <Form.Group size="lg" controlId="Usuario">
                            <Form.Label className="form__labels">Teléfono <RequieredInputs/> </Form.Label>
                                <Form.Control
                                    className="user-input"
                                    name="Telefono"
                                    minLength="9"
                                    type="text"
                                    value={telefono}
                                    onChange={handleChange}
                                    placeholder="Teléfono"
                                />
                            </Form.Group>
                            <button
                                onClick={handleSubmit}
                                disabled={isDisable || !validateForm()}
                                className="btn-landing"
                            >
                                GO
                            </button>
                        </Form>
                </div>
            </div>
        </>
    )
}

export default LandingToPresentation